/**
 * Utilitários de formatação de datas para o padrão brasileiro
 */

/**
 * Formata uma data para o padrão brasileiro dd/mm/yyyy
 */
export function formatDateBR(date: Date | string): string {
  // Para strings ISO (yyyy-mm-dd), fazer split manual para evitar
  // deslocamento de timezone (new Date("2026-01-01") é interpretado
  // como meia-noite UTC, que no fuso BR vira o dia anterior).
  if (typeof date === "string") {
    const isoMatch = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
    }
  }

  const d = typeof date === "string" ? new Date(date) : date;
  if (isNaN(d.getTime())) return "";

  const day = d.getDate().toString().padStart(2, "0");
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
}

/*/**
 * Retorna o nome do mês em português
 */
function getMonthName(monthIndex: number): string {
  const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  return months[monthIndex] || "";
}

/**
 * Formata o nome do mês a partir de uma string yyyy-mm
 */
export function formatMonthLabel(monthLabel: string): string {
  if (!monthLabel) return "";

  const [year, month] = monthLabel.split("-");
  if (!year || !month) return monthLabel;

  const monthIndex = parseInt(month, 10) - 1;
  return `${getMonthName(monthIndex)} ${year}`;
}
